/* dashboard header css */
import styled from 'styled-components';

export const LoginDiv = styled.div`
  /* Global reset helpers */
  *, *::before, *::after { box-sizing: border-box; }

  .container-signup { padding: 0; }

  /* Layout */
  .signup-row {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    min-height: 100vh;          /* fill screen height */
    gap: 32px;
  }

  .signup-content-left,
  .signup-content-right {
    width: 50%;
  }

  /* Left pane header block */
  .signup-row .signup-content-left .img-head {
    background-color: #083ac8;
    padding: 20px 0px 20px 0px;
    color: #fff;
    text-align: center;
    font-family: 'Montserrat', sans-serif;
  }

  .signup-row .signup-content-left .img-head h1 {
    font-size: clamp(28px, 2.5vw, 40px);
    font-weight: 700;
  }

  .signup-row .signup-content-left .img-head p {
    font-size: clamp(12px, 0.95vw, 15px);
  }

  /* Image wrapper to prevent clipping */
  .signup-content-left {
    display: flex;
    flex-direction: column;
    overflow: visible; /* ensure image isn't hidden */
  }

  /* Put your image inside a wrapper if not already */
  .img-wrap {
    flex: 1 1 auto;             /* take remaining height */
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
  }

  /* Image rules – no clipping at any aspect ratio */
  .img-login {
    max-width: 100%;
    max-height: calc(80vh - 200px); /* header + padding allowance */
    height: auto;
    width: auto;                     /* prevent forced stretching */
    object-fit: contain;             /* contain within box */
    object-position: center;
    display: block;
  }

  /* Right pane */
  .signup-content-right {
    padding-left: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center; /* vertical center form */
  }

  .signup-content-right h2 {
    font-size: clamp(24px, 2vw, 30px);
    font-weight: 700;
    font-family: 'Montserrat', sans-serif;
    letter-spacing: -0.09px;
    color: #212529;
  }

  .text-danger { font-size: 12px; padding-top: 3px; }

  .signup-content-right .divition {
    width: 69px; height: 8px; background-color: #083ac8;
  }

  .signup-content-right form label {
    font-size: 13px;
    line-height: 1.85;
    letter-spacing: 0.12px;
    color: rgba(0, 0, 0, 0.6);
  }

  .signup-content-right form .form-control {
    height: 40px;
    border: 1px solid rgba(0, 0, 0, 0.32);
    background-color: #fff;
    font-size: 13px;
    line-height: 1.85;
    letter-spacing: 0.12px;
    color: rgba(0, 0, 0, 0.6);
  }

  .signup-content-right form .btn-block.btn-primary {
    height: 40px;
    border-radius: 4px;
    border: 1px solid #083ac8;
    background-color: #083ac8;
    font-size: 13px;
    font-weight: bold;
    color: #fff;
    text-transform: uppercase;
  }

  .signup-content-right .login-bootom-text {
    font-size: 12px;
  }
  .signup-content-right .login-bootom-text b a { text-decoration: underline; }

  /* ===== Desktop wide (1920x1080 and up) ===== */
  @media (min-width: 1600px) {
    .signup-content-right { padding-left: 64px; }
    .img-login { max-height: calc(80vh - 200px); }
  }

  /* ===== Laptop / small desktop (1366–1599) ===== */
  @media (max-width: 1599px) {
    .signup-content-right { padding-left: 40px; }
    .img-login { max-height: calc(80vh - 200px); }
  }

  /* ===== Tablet - stack columns ===== */
  @media (max-width: 991px) {
    .signup-row {
      flex-direction: column;
      gap: 20px;
      padding: 20px 16px;
      min-height: auto;  /* let it grow naturally */
    }

    .signup-content-left,
    .signup-content-right { width: 100%; }

    .signup-content-right {
      padding-left: 0;
      padding-right: 0;
    }

    .img-wrap { padding: 12px 0; }
    .img-login { max-height: 48vh; }  /* keep image visible on tablets */
  }

  /* ===== Small phones ===== */
  @media (max-width: 480px) {
    .signup-row .signup-content-left .img-head h1 { font-size: 22px; }
    .signup-content-right h2 { font-size: 20px; }
    .img-login { max-height: 40vh; }
  }
`;
